import React, { useState, useEffect, useRef } from 'react';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';

import { cn } from '../../../tailwind-base/utils';
import { Button } from '../../shadcn/Button';
import { useUiComponentsInternationalContext } from '../../../static-translations/src';

interface Props {
  description: string;
}

export default function ProductDescription({ description }: Readonly<Props>) {
  const ref = useRef(null);
  const { tt } = useUiComponentsInternationalContext();

  const [isMounted, setIsMounted] = useState(false);
  const [readMore, setReadMore] = useState(false);
  const [height, setHeight] = useState(0);

  const maxHeight = 160;
  const heightExceedsMax = height >= maxHeight;

  useEffect(() => {
    if (isMounted) setHeight(ref?.current?.clientHeight);
    else if (!isMounted) setIsMounted(true);
  }, [isMounted]);

  return (
    <>
      <div
        aria-describedby="product-description"
        className={cn(
          'flex flex-col items-start',
          !readMore && heightExceedsMax
            ? 'text-transparent bg-clip-text bg-gradient-to-b from-foreground from-60% to-background overflow-hidden'
            : ''
        )}
        ref={ref}
      >
        <div
          className={readMore ? '' : 'line-clamp-7'}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: description }}
          id="product-description"
          style={{ maxHeight: !readMore && `${maxHeight}px` }}
        />
      </div>
      {heightExceedsMax && (
        <Button
          aria-controls="product-description"
          aria-expanded={readMore}
          className="px-1 rounded-none w-full flex justify-between border-b border-border focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2 focus:outline-transparent focus:outline-0"
          onClick={() => setReadMore(!readMore)}
          variant="ghost"
        >
          {readMore
            ? tt(s => s.productContainerDeptComponents.readLessLabel)
            : tt(s => s.productContainerDeptComponents.readMoreLabel)}
          {readMore ? <MdExpandLess size={24} /> : <MdExpandMore size={24} />}
        </Button>
      )}
    </>
  );
}
